import * as constants from "./constants";

export const fetchEnrollmentHistory = (data) => {
  return {
    type: constants.FETCH_ENROLLMENT_HISTORY,
    data,
  };
};

export const fetchEnrollmentHistorySuccess = (data) => {
  return {
    type: constants.FETCH_ENROLLMENT_HISTORY_SUCCESS,
    payload: data,
  };
};

export const fetchEnrollmentHistoryError = (data) => {
  return {
    type: constants.FETCH_ENROLLMENT_HISTORY_ERROR,
    data: data,
  };
};

export const isAddingAction = (data) => {
  return {
    type: constants.IS_ADDING_UPDATE,
    data,
  };
};

export const setStorage = (data) => {
  return {
    type: constants.SET_ENROLLMENT_HISTORY_MANAGER_STATE,
    data,
  };
};
